import { render, staticRenderFns } from "./deprecated-icons.vue?vue&type=template&id=767657ff"
import script from "./deprecated-icons.vue?vue&type=script&lang=js"
export * from "./deprecated-icons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports